var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 179,
    viewBox: "0 0 149 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_115_2380)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.527 123.262C201.339 133.34 195.568 140.127 193.283 142.756C182.262 155.388 166.452 157.06 161.797 157.582C148.27 159.059 137.732 154.997 132.32 152.823C126.441 150.468 119.769 145.925 106.652 136.954C90.4497 125.832 90.489 124.756 85.1127 122.643C72.6455 117.684 68.5145 121.923 54.9577 118.836C49.6917 117.634 30.4837 113.239 20.4999 96.3346C14.2806 85.8592 10.985 69.5153 17.9154 57.6128C24.4399 46.4262 35.6068 46.7274 36.3554 39.1684C37.2655 29.5313 19.3425 27.0455 14.3424 12.9214C8.50639 -3.60928 22.4452 -30.4993 41.6903 -37.64C58.6229 -43.9205 74.0761 -32.9034 83.452 -42.7813C89.2422 -48.8903 85.7637 -55.6024 90.9863 -58.9174C100.421 -64.8957 114.229 -44.3936 135.603 -42.7628C159.409 -40.9238 164.445 -64.6908 188.035 -65.8113C217.036 -67.1911 243.644 -32.8351 253.579 -5.84762C255.213 -1.45921 268.776 35.4403 253.544 49.2343C242.27 59.4142 225.65 47.5558 206.214 60.8051C203.785 62.4613 188.9 72.572 189.685 84.6984C190.274 93.9748 199.596 97.7512 202.188 113.641C202.943 118.769 202.614 122.199 202.527 123.262Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_115_2380",
    x: 0,
    y: -78.8516,
    width: 281.701,
    height: 257.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0823529 0 0 0 0 0.168627 0 0 0 0 0.0313726 0 0 0 0.63 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_115_2380"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_115_2380",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.f5ce4aa215de7bad15e6304ec100e3a2.svg";
export { ForwardRef as ReactComponent };